import Container from "./Container"

function App(props: any) {
  const { module, version } = props;

  return (
    <>
      <Container module={module} version={version} />
    </>
  );
}

export default App;
